import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestDeleteMarketingTemplate } from "./deleteMarketingTemplate.request";

const useDeleteMarketingTemplate = (
  options?: MutationOptions<
    { ok: boolean },
    ApiServiceError<ApiError>,
    string
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestDeleteMarketingTemplate,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["marketing", "templates"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useDeleteMarketingTemplate;
